/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useCallback, useEffect, useContext,
} from 'react';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import InvoicesListSkeleton from '../Invoices/listSkeleton';
import Pagination from '../../Components/Pagination';
import FilterModal from './FilterModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import ReturnRequestListing from './ReturnRequestList';
import ApproveAndRejectModal from './ApproveAndRejectModal';

function ManageReturnRequests() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [invoiceList, setinvoiceList] = useState([]);
    const [threeplList, setThreeplList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [isEditId, setisEditId] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [sortType, setsortType] = useState('TRX_DATE+desc');
    const [searchValue, setsearchValue] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [returnReason, setReturnReason] = useState('');
    const [filterModal, setFilterModal] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [response, setResponse] = useState('');
    const [selectedInvoice, setSelectedInvoice] = useState({});
    const [threeDotsLoader, setThreeDotsLoader] = useState(false);
    const [Filter, setFilter] = useState({
        order_category: [],
        return_status: [],
    });
    const [selected, setselected] = useState({
        invoice_start_date: '',
        invoice_end_date: '',
        order_start_date: '',
        order_end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data.data.success_status === true) {
            setThreeplList(data.data.Items);
        }
    };

    const handleFetchInvoices = useCallback((() => {
        distributorService.ReturnRequestList(currentPage, sortType, searchValue, filterValue).then((resp) => {
            if (resp.error === false && resp.data.data.success_status) {
                if (resp?.data?.data?.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setinvoiceList(resp.data.data.Items);
                setCurrentPage(resp.data.data.current_page);
                setTotalPage(resp.data.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, filterValue, sortType]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };
    const handleApproveRequest = async () => {
        setThreeDotsLoader(true);
        const body = {
            return_request_status: response,
            return_request_admin_respons: returnReason,
        };
        const data = await distributorService.UploadInvoiceDocuments(selectedInvoice.INDENT_NUMBER, selectedInvoice.INVOICE_NO, body);
        if (data.data.success_status === true) {
            setApproveModal(false);
            setThreeDotsLoader(false);
            handleFetchInvoices();
            setReturnReason('');
        } else {
            SetErrorMessage('Something went wrong');
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.ReturnRequestList(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchthreepl();
        handleFetchInvoices();
    }, [handleFetchInvoices]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px] top-0 left-0">
                <h5 className="text-xs4 font-normal text-[#555259]">Return Requests</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[80px] absolute ${exportClick ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[12]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <InvoicesListSkeleton />
                : (
                    <div>
                        {invoiceList.length > 0 && (
                            <ReturnRequestListing
                                setinvoiceList={setinvoiceList}
                                invoiceList={invoiceList}
                                isEditId={isEditId}
                                setisEditId={setisEditId}
                                sortType={sortType}
                                setsortType={setsortType}
                                emptyData={emptyData}
                                setEmptyData={setEmptyData}
                                searchValue={searchValue}
                                handleFetchInvoices={handleFetchInvoices}
                                approveModal={approveModal}
                                setApproveModal={setApproveModal}
                                setResponse={setResponse}
                                selectedInvoice={selectedInvoice}
                                setSelectedInvoice={setSelectedInvoice}
                            />
                        )}
                        {invoiceList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={invoiceList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                Filter={Filter}
                                setFilter={setFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFilter={handleFilter}
                                threeplList={threeplList}
                                setThreeplList={setThreeplList}
                                handleFetchInvoices={handleFetchInvoices}
                                selected={selected}
                                setselected={setselected}
                                SetSuccessMessage={SetSuccessMessage}
                            />
                        )}
                        {approveModal && (
                            <ApproveAndRejectModal
                                approveModal={approveModal}
                                setApproveModal={setApproveModal}
                                handleApproveRequest={handleApproveRequest}
                                returnReason={returnReason}
                                setReturnReason={setReturnReason}
                                threeDotsLoader={threeDotsLoader}
                                setThreeDotsLoader={setThreeDotsLoader}
                            />
                        )}
                        {emptyData && (
                            <EmptyScreen
                                search="yes"
                                text="No Return Requests"
                                buttonRequired={false}
                                all={searchValue.length > 0 ? 'under searched term' : 'found'}
                            />
                        )}
                    </div>
                )}
        </div>
    );
}

export default ManageReturnRequests;
